module.exports = __webpack_public_path__ + "img/home_hotel_bg.9d1eba0f.jpg";